import template from 'text!./templates/Currency.html';

export default [function () {
    return {
        restrict: 'E',
        scope: {
            item: '&'
        },
        template: template,
        link: function link($scope) {
            return $scope.$watch('item()', function (item) {
                $scope.applyNewValue = function (val) {
                    return item.setValue(val);
                };
                $scope.currency = item.getPropertyInfo().getCurrency();
            });
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/dataItems/form/Currency.js
// module id = 275
// module chunks = 0